Wee.fn.make('modal', {
	init: function() {
		var scope = this;

		this.$modal = $('ref:modalForm');

		$.events.on({
			'ref:modalToggle': {
				click: function() {
					scope.toggle();
				}
			},
			'ref:modalClose': {
				click: function() {
					scope.close();
				}
			}
		});
	},

	toggle: function(el) {
		this.$modal.toggle();
		$($._body).toggleClass('-is-disabled');
	},

	close: function() {
		this.$modal.hide();
		$($._body).removeClass('-is-disabled');
	}
});
